import React from "react";
import "./UiCheckbox.css";
import { useState } from "react";
import UiIcon from "../UiIcon";
import { ICON } from "../../../assets";

const checkboxSizeVariants = {
  sm: "ui-checkbox--small",
  md: "ui-checkbox--medium",
  lg: "ui-checkbox--large",
};

const CheckboxColors = {
  successColor: "#2CB42B",
  highlightColor: "#FFA500",
  brand: "#FCA2AD",
  lightCream: "#F4D5B7",
  critical: "#B22222",
};

function UiCheckbox({
  size = "md",
  checked = false,
  onChange,
  label,
  color = CheckboxColors.brand,
  className = "",
  style = {},
}) {
  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = (event) => {
    const newCheckedState = event.target.checked;
    setIsChecked(newCheckedState);

    if (onChange) {
      onChange(newCheckedState);
    }
  };

  const sizeClass = checkboxSizeVariants[size] || checkboxSizeVariants.medium;

  const iconSize = size === "lg" ? "md" : size === "sm" ? "xs" : "sm";

  return (
    <React.Fragment>
      <label
        className={`ui-checkbox-container ${sizeClass} ${className}`}
        style={style}
      >
        <input
          type="checkbox"
          className="ui-checkbox-native"
          checked={isChecked}
          onChange={handleChange}
        />
        <div
          className="ui-checkbox-visual"
          style={{
            backgroundColor: isChecked ? color : "#fff",
            borderColor: isChecked ? color : "#ccc",
          }}
        >
          <span className="ui-checkbox-checkmark">
            {isChecked ? <UiIcon icon={ICON.CheckIcon} size={iconSize} /> : ""}
          </span>
        </div>

        {label && <span>{label}</span>}
      </label>
    </React.Fragment>
  );
}

export default UiCheckbox;

export { CheckboxColors, checkboxSizeVariants };
